import Registry from '../../../global/Registry';
import AuthenticationToken from '../domain/aggregates/authenticationToken/AuthenticationToken';
import Api from '../../../../foundation/api/Api';

export default class AuthenticationTokenApi extends Api<AuthenticationToken> {

	private static instance?: AuthenticationTokenApi;

	public static getInstance () {
		return this.instance !== undefined ? this.instance : this.instance = new this(Registry.getInstance().authenticationTokenRepository);
	}

	public async createToken (data = {}) {
		return await this.postOne('/api/authentication-token', data);
	}

	public async getTokenOrCurrent (data = {}) {
		const token = Registry.getInstance().authenticationTokenRepository.getToken();

		if (token !== undefined) {
			return token;
		}

		return await this.createToken(data);
	}

	public async revokeToken (authenticationToken: AuthenticationToken) {
		await this.postOne(['/api/authentication-token/', authenticationToken.getId(), '/revoke']);
	}
}


// WEBPACK FOOTER //
// ./code/project/modules/users/api/AuthenticationTokenApi.ts